import React from 'react';

import MuiAccordionSummary, {
  AccordionSummaryProps as MuiAccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const AccordionSummary = withCoreProps<AccordionSummaryProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<AccordionSummaryProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiAccordionSummary {...props} className={clsxClass}>
        {children}
      </MuiAccordionSummary>
    );
  },
);

export interface AccordionSummaryProps
  extends MuiAccordionSummaryProps,
    CoreProps {}
